import script from "./NoteEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteEdit.vue?vue&type=script&setup=true&lang=js"

import "./NoteEdit.vue?vue&type=style&index=0&id=06006c0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06006c0b"]])

export default __exports__